webpackJsonp([109],{

/***/ 0:
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(10);
	
	__webpack_require__(16);
	
	__webpack_require__(12);
	
	__webpack_require__(8);
	
	__webpack_require__(32);
	
	__webpack_require__(19);
	
	__webpack_require__(3);
	
	__webpack_require__(9);
	
	__webpack_require__(62);
	
	__webpack_require__(1);
	
	__webpack_require__(6);
	
	__webpack_require__(5);
	
	__webpack_require__(7);
	
	__webpack_require__(27);
	
	__webpack_require__(2);
	
	__webpack_require__(21);
	
	__webpack_require__(11);
	
	$(function() {
	  var $form_fix;
	  $form_fix = $('.form_fix');
	  return $(window).scroll(function() {
	    if ($(window).scrollTop() < 400) {
	      return $form_fix.fadeOut();
	    } else {
	      return $form_fix.fadeIn();
	    }
	  });
	});
	
	
	/*do ->
	  $swiperProcess = $('#swiper-process')
	  $swiper = new Swiper $swiperProcess,{
	    autoplay: 3000,
	    prevButton:'.swiper-button-prev',
	    nextButton:'.swiper-button-next',
	    pagination:'.swiper-pagination',
	    paginationClickable :true,
	    spaceBetween: 5,
	    loop : true,
	    autoheight : true,
	    autoplayDisableOnInteraction : false,
	  }
	 */
	
	(function() {
	  var $form, $mobile, $truename, success_url;
	  if ($('#yuyue_form').length > 0) {
	    $form = $('#yuyue_form');
	    $truename = $form.find('[name="truename"]');
	    $mobile = $form.find('[name="mobile"]');
	    success_url = $("#success_url").val();
	    $form.validate({
	      errorPlacement: function(error, element) {
	        return swal({
	          title: error[0].innerHTML,
	          allowOutsideClick: true
	        });
	      },
	      submitHandler: function(form) {
	        var phoneNumber, userId;
	        phoneNumber = form.elements.mobile.value.trim();
	        userId = "MOBI" + phoneNumber;
	        $(form).ajaxSubmit({
	          dataType: 'json',
	          data: {
	            rnd: parseInt(Math.random() * 1e7, 10) + (new Date()).getTime()
	          },
	          error: function() {
	            return swal({
	              title: '对不起，出错了，请稍后重试！',
	              allowOutsideClick: true
	            });
	          },
	          success: function(res) {
	            if (res.msg[0].type === 'success') {
	              swal({
	                customClass: 'alert-success',
	                title: '<img class="form_success" src="' + success_url + '" alt="">',
	                confirmButtonText: '返  回',
	                confirmButtonColor: '#3b9bff',
	                allowOutsideClick: true,
	                html: true
	              });
	            }
	            if (res.msg[0].type === 'error') {
	              swal({
	                title: res.msg[0].info,
	                allowOutsideClick: true
	              });
	              return false;
	            }
	          }
	        });
	        return false;
	      }
	    });
	    $truename.rules('add', {
	      required: true,
	      messages: {
	        required: '请输入您的姓名'
	      }
	    });
	    return $mobile.rules('add', {
	      required: true,
	      mobileNum: true,
	      messages: {
	        required: '请输入11位手机号码',
	        mobileNum: '请输入正确的手机号'
	      }
	    });
	  }
	})();
	
	(function() {
	  var $colpmask, $cshhr, $cshhrclose;
	  $cshhr = $('#cshhrbtn');
	  $cshhrclose = $('.cshhrclose');
	  $colpmask = $('.colpmask');
	  $cshhr.bind('click', function(evt) {
	    evt.preventDefault();
	    return $colpmask.show();
	  });
	  return $cshhrclose.bind('click', function(evt) {
	    evt.preventDefault();
	    return $colpmask.hide();
	  });
	})();
	
	(function() {
	  var $agreement, $area, $dl, $form, $mobile;
	  if ($('#fromSubmit').length > 0) {
	    $form = $('#fromSubmit');
	    $area = $form.find('[name="area"]');
	    $mobile = $form.find('[name="mobile"]');
	    $dl = $form.find('[name="dl"]');
	    $agreement = $form.find('[name = agreement]');
	    $form.validate({
	      errorPlacement: function(error, element) {
	        return swal({
	          title: error[0].innerHTML,
	          allowOutsideClick: false
	        });
	      },
	      submitHandler: function(form) {
	        var phoneNumber, userId;
	        phoneNumber = form.elements.mobile.value.trim();
	        userId = "MOBI" + phoneNumber;
	        $(form).ajaxSubmit({
	          dataType: 'json',
	          data: {
	            rnd: parseInt(Math.random() * 1e7, 10) + (new Date()).getTime()
	          },
	          error: function() {
	            return swal({
	              title: '对不起，出错了，请稍后重试！',
	              allowOutsideClick: true
	            });
	          },
	          success: function(res) {
	            var ref, ref1;
	            if (((ref = res.msg) != null ? (ref1 = ref[0]) != null ? ref1.type : void 0 : void 0) === 'success') {
	              window._agl && window._agl.push([
	                'track', [
	                  'success', {
	                    t: 3
	                  }
	                ]
	              ]);
	              if ($dl.val()) {
	                swal({
	                  title: '您的信息已提交成功，请注意短信查收报价结果!',
	                  allowOutsideClick: true
	                });
	              } else {
	                swal({
	                  customClass: 'alert-success',
	                  title: '<img class="form_success" src="http://p.51zx.com/FuK_TJTSwVZBR7Ho2nAj1_z3THKw" alt="">',
	                  confirmButtonText: '返  回',
	                  confirmButtonColor: '#3b9bff',
	                  allowOutsideClick: true,
	                  html: true,
	                  timer: 1000000
	                });
	              }
	            }
	            if (res.msg[0].type === 'error') {
	              swal({
	                title: res.msg[0].info,
	                allowOutsideClick: true
	              });
	              return false;
	            }
	          }
	        });
	        return false;
	      }
	    });
	    if ($agreement.length) {
	      $agreement.rules('add', {
	        required: true,
	        messages: {
	          required: '请勾选已阅读并同意积木家的用户协议'
	        }
	      });
	    }
	    if ($area.length) {
	      $area.rules('add', {
	        required: true,
	        messages: {
	          required: '请输入装修面积'
	        }
	      });
	    }
	    if ($mobile.length) {
	      return $mobile.rules('add', {
	        required: true,
	        mobileNum: true,
	        messages: {
	          required: '请输入11位手机号码',
	          mobileNum: '请输入正确的手机号'
	        }
	      });
	    }
	  }
	})();
	
	(function() {
	  var $colpmask, $form, $imageCity, $mobile, $truename, success_url;
	  if ($('#cshhrfrom').length > 0) {
	    $form = $('#cshhrfrom');
	    $truename = $form.find('[name="truename"]');
	    $mobile = $form.find('[name="mobile"]');
	    $imageCity = $form.find('[name="imageCity"]');
	    success_url = $("#success_url").val();
	    $colpmask = $('.colpmask');
	    $form.validate({
	      errorPlacement: function(error, element) {
	        return swal({
	          title: error[0].innerHTML,
	          allowOutsideClick: true
	        });
	      },
	      submitHandler: function(form) {
	        var phoneNumber, userId;
	        phoneNumber = form.elements.mobile.value.trim();
	        userId = "MOBI" + phoneNumber;
	        $(form).ajaxSubmit({
	          dataType: 'json',
	          data: {
	            rnd: parseInt(Math.random() * 1e7, 10) + (new Date()).getTime()
	          },
	          error: function() {
	            return swal({
	              title: '对不起，出错了，请稍后重试！',
	              allowOutsideClick: true
	            });
	          },
	          success: function(res) {
	            if (res.msg[0].type === 'success') {
	              $colpmask.hide();
	              swal({
	                customClass: 'alert-success',
	                title: '<img class="form_success" src="http://p.51zx.com/FnUeQxS48RolFiKq0ygMOuZ-MZFS" alt="">',
	                confirmButtonText: '返  回',
	                confirmButtonColor: '#3b9bff',
	                allowOutsideClick: true,
	                html: true
	              });
	              $truename.val('');
	              $mobile.val('');
	              $imageCity.val('');
	            }
	            if (res.msg[0].type === 'error') {
	              swal({
	                title: res.msg[0].info,
	                allowOutsideClick: true
	              });
	              return false;
	            }
	          }
	        });
	        return false;
	      }
	    });
	    $truename.rules('add', {
	      required: true,
	      messages: {
	        required: '请输入您的姓名'
	      }
	    });
	    $imageCity.rules('add', {
	      required: true,
	      messages: {
	        required: '请输入计划开店城市'
	      }
	    });
	    return $mobile.rules('add', {
	      required: true,
	      mobileNum: true,
	      messages: {
	        required: '请输入11位手机号码',
	        mobileNum: '请输入正确的手机号'
	      }
	    });
	  }
	})();
	
	(function() {
	  var $height, $kefu, $mfdh, $rightFloat, $yuyuefix, iHeight;
	  $rightFloat = $('#right-float');
	  $kefu = $('#kefu');
	  $yuyuefix = $('.yuyuefix');
	  $mfdh = $('.mfdh');
	  if ($kefu.length > 0) {
	    if ($yuyuefix.length > 0) {
	      iHeight = $rightFloat.offset().top;
	      $height = $("body").height() - ($(window).height() - 136);
	      return $(window).scroll(function() {
	        var scrollTop;
	        $mfdh.hide();
	        scrollTop = $(window).scrollTop();
	        if ($height <= scrollTop) {
	          return $yuyuefix.stop().animate({
	            bottom: -85
	          }, 50);
	        } else if (480 <= scrollTop) {
	          $rightFloat.stop().animate({
	            right: 30
	          }, 50);
	          return $yuyuefix.stop().animate({
	            bottom: 0
	          }, 50);
	        } else {
	          $rightFloat.stop().animate({
	            right: -70
	          }, 50);
	          return $yuyuefix.stop().animate({
	            bottom: -85
	          }, 50);
	        }
	      });
	    }
	  }
	})();


/***/ },

/***/ 62:
3

});


/** WEBPACK FOOTER **
 ** colp.d7686ee819c046212589.js
 **/